/**
 * Menu group identifiers for navigation organization
 * Separated to avoid circular dependency issues
 */
export const MenuGroups = {
  PUBLIC: 'public',      // Always visible (about, contact, simulations)
  ACCOUNT: 'account',    // Logged-in users (profile)
  CONTENT: 'content',    // Content creators (surveys)
  TRAINING: 'training',  // Trainers (future pages)
  ADMIN: 'admin',        // Admins (system management)
};
